import React from "react";
import WrappedSidebarV2 from "../../v2/ui/components/SidebarV2";

const Page = (args) => (
  <div id="container-app" className="flex">
    <WrappedSidebarV2 />
    <div className="container-flex">
      <args.component {...args.props} />
    </div>
  </div>
);

export default Page;
